module.exports = __webpack_public_path__ + "img/productCatalogHeader.d5a31fd8.svg";